import React from 'react'
import Menu from 'general/components/Menu/Menu.container'
import TopBar from 'general/components/TopBar/TopBar.component'
import { Switch, Redirect, Route } from 'react-router-dom'
import AnalyticsSectionsSideBar from 'analytics/components/AnalyticsSectionsSideBar/AnalyticsSectionsSideBar.component'
import Sections from 'analytics/components/Sections'

import { isEmbedded as embeddedFunc } from 'shared/utils/iframeHandler'
import styles from './Analytics.module.scss'

const Analytics = () => {
  const isEmbedded = embeddedFunc()
  return (<main className={styles.layout}>
    {!isEmbedded && <section className={styles.topBar}>
      <TopBar />
    </section>}

    <div className={styles.panel}>

      { !isEmbedded && <section className={styles.menu}>
        <Menu />
      </section>}

      <section className={styles.main}>
        <div className={styles.contentWrapper}>

          <AnalyticsSectionsSideBar />

          <Switch>
            <Route path='/analytics/:section' component={Sections} />

            <Redirect
              from='/analytics'
              to='/analytics/interactions'
            />
            <Redirect
              from='/'
              to='/analytics/interactions'
            />
          </Switch>

        </div>
      </section>

    </div>

  </main>
  )
}

Analytics.propTypes = {}

export default Analytics
